import { request } from "./client";
import type { ProductDetail } from "./products";

export const serviceFields = [
  { key: "material", title: "材质", max: 500 },
  { key: "shippingLeadTime", title: "生产周期", max: 100 },
  { key: "shippingDescription", title: "生产与发货说明", max: 500 },
  { key: "freeShippingDescription", title: "定制运费说明", max: 500 },
  { key: "guaranteeDescription", title: "保障说明", max: 500 },
  { key: "invoiceDescription", title: "发票说明", max: 500 },
  { key: "craftsmanshipDescription", title: "工艺说明", max: 500 },
] as const;
export type ServiceKey = typeof serviceFields[number]["key"];
export type ServiceValues = Record<Exclude<ServiceKey, "material">, string | null>;
export interface ServiceConfigItem { visible: boolean; sortOrder: number; title?: string | null; summary?: string | null }
export interface CustomServiceItem { id: string; title: string; content: string; summary?: string | null; visible: boolean; sortOrder: number }
export interface ServiceConfig {
  standard: Record<ServiceKey, ServiceConfigItem>;
  materialText: string | null;
  custom: CustomServiceItem[];
}
export interface ServiceInfoState { version: number; config: ServiceConfig | null }
export interface ServiceCandidate { id: string; title: string; summary: string; content: string }
export async function listServiceCandidates(): Promise<ServiceCandidate[]> {
  return (await request<ServiceCandidate[]>("/admin/products/service-info-candidates")).data;
}
export async function saveProductServiceInfo(product: ProductDetail, values: ServiceValues, config: ServiceConfig, version: number): Promise<ProductDetail> {
  return (await request<ProductDetail>(`/admin/products/${product.id}/service-info`, {
    method: "PUT", body: JSON.stringify({ values, config, expectedUpdatedAt: product.updatedAt, expectedVersion: version }),
  })).data;
}
